import { UserPlusIcon } from "@heroicons/react/24/outline";
import { ReferenceBusinessId } from "@sp-crm/core";
import { PrimaryButton } from "components/ui/primary-button";
import { SecondaryButton } from "components/ui/secondary-button";
import {
    useCreateReferenceContactMutation,
    usePatchReferenceContactMutation,
} from "generated/graphql";
import React, { useCallback } from "react";
import { navigate } from "store/actions";
import { useRegionId } from "store/selectors/hooks";

interface AddNewContactButtonProps {
    buttonStyle?: "primary" | "secondary";
    businessId?: ReferenceBusinessId;
}

export const AddNewContactButton = ({
    buttonStyle = "primary",
    businessId,
}: AddNewContactButtonProps) => {
    const createReferenceContactMutation = useCreateReferenceContactMutation();
    const patchReferenceContactMutation = usePatchReferenceContactMutation();
    const regionId = useRegionId();

    const handleAddContact = useCallback(
        async (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
            e.preventDefault();
            const response = await createReferenceContactMutation.mutateAsync({
                regionId,
            });

            if (response?.createReferenceContact?.id) {
                if (businessId) {
                    await patchReferenceContactMutation.mutateAsync({
                        id: response.createReferenceContact.id,
                        businessId,
                    });
                }
                navigate(
                    `/references/contacts/show/${response.createReferenceContact.id}`,
                );
            }
        },
        [
            createReferenceContactMutation,
            patchReferenceContactMutation,
            regionId,
            businessId,
        ],
    );

    const ButtonComponent = buttonStyle === "secondary" ? SecondaryButton : PrimaryButton;

    return (
        <ButtonComponent onClick={handleAddContact}>
            <div className="flex items-center md:space-x-2">
                <UserPlusIcon className="w-5 h-5" />
                <span className="text-sm max-md:hidden">New contact</span>
            </div>
        </ButtonComponent>
    );
};
